<template>
    <div class="field mb-1">
        <table class="table is-fullwidth is-countable mb-05 is-borderless">
            <thead>
            <tr>
                <th class="is-narrow"></th>
                <th>
                    {{ typeText }}
                    <span v-if="num_attendees">จำนวน {{ num_attendees }} คน ได้แก่</span>
                </th>
                <th class="is-narrow">จำนวนผู้เข้าร่วม</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(attendee, attendeeIndex) in attendees">
                <td class="is-counter">
                    <input type="hidden"
                           :name="'activities[' + activityIndex + '][attendees][' + type + '][' + attendeeIndex + '][id]'"
                           v-model="attendee.id"
                    />
                </td>
                <td>
                    <textarea class="textarea"
                              :placeholder="placeholder"
                              :name="'activities[' + activityIndex + '][attendees][' + type + '][' + attendeeIndex + '][title]'"
                              v-model="attendee.title"
                              rows="1"
                              v-autosize
                    ></textarea>
                </td>
                <td class="is-narrow">
                    <div class="field is-grouped">
                        <div class="field is-expanded">
                            <input class="input" type="number"
                                   :name="'activities[' + activityIndex + '][attendees][' + type + '][' + attendeeIndex + '][num_attendees]'"
                                   v-model.number="attendee.num_attendees"
                                   size="3"
                            />
                        </div>
                        <p class="field ml-1">คน</p>
                    </div>
                </td>
                <td class="is-narrow">
                    <span v-if="attendeeIndex > 0"
                          class="delete"
                          tabindex="-1"
                          @click.prevent="deleteAttendee(attendee)"></span>
                </td>
            </tr>
            <tr>
                <td></td>
                <td>
                    <button type="button" class="button is-300"
                            @click.prevent="addAttendee"
                            :class="type == 'internal' ? 'tooltip': ''"
                            :data-tooltip="type == 'internal' ? 'ไม่รวมนิสิต': ''"
                    >
                        <span class="icon"><i class="fa fa-plus"></i></span> &nbsp;
                        เพิ่มผู้เข้าร่วม
                    </button>
                </td>
                <td></td>
                <td></td>
            </tr>
            </tbody>
        </table>

    </div>
</template>
<script type="text/babel">
    export default {
        props: {
            activity: {type: Object, required: true},
            activityIndex: {type: Number, required: true},
            type: {type: String, required: true},
        },
        computed: {
            typeText() {
                return this.type == 'internal' ?
                    'ผู้เข้าร่วมภายในหน่วยงาน/มหาวิทยาลัย ' :
                    'ผู้เข้าร่วมภายนอกมหาวิทยาลัย (นิสิต/บุคคลทั่วไป)';
            },
            placeholder() {
                return this.type == 'internal' ?
                    'ระบุผู้เข้าร่วมภายใน' :
                    'ระบุผู้เข้าร่วมภายนอก';
            },
            attendees() {
                return this.activity.attendees.filter((attendee) => attendee.type == this.type);
            },
            num_attendees() {
                return _.sumBy(this.attendees, (attendee) => parseInt(
                    !_.isNull(attendee.num_attendees) ?
                        attendee.num_attendees :
                        0
                ));
            }
        },
        created() {
            if (this.attendees.length == 0) {
                this.addAttendee();
            }
        },
        methods: {
            addAttendee() {
                this.activity.attendees.push({
                    id: null,
                    type: this.type,
                    title: null,
                    num_attendees: null,
                })
            },
            deleteAttendee(attendee) {
                this.activity.attendees.splice(
                    _.findIndex(this.activity.attendees, attendee),
                    1
                );
            }
        }
    }
</script>